import settings from '@nobia/zeus-components/lib/settings'
import { createCloudinaryUrl } from '../components/image/Image'
import magnet from './magnet/index'
import marbodal from './marbodal/index'
import invita from './invita/index'
import sigdal from './sigdal/index'
import norema from './norema/index'
import novart from './novart/index'

const brands = {
  magnet,
  marbodal,
  invita,
  sigdal,
  norema,
  novart,
}

const cloudinaryDelivery = {
  fetch_format: 'auto',
  quality: 'auto:eco',
}

export const data = brands[settings.brand].map(item => ({
  ...item,
  cards: item.cards?.map(card => ({
    ...card,
    image: createCloudinaryUrl(card.image, {
      width: 640,
      height: 480,
      crop: 'fill',
      ...cloudinaryDelivery,
    }),
    imageSrc: createCloudinaryUrl(card.imageSrc, {
      crop: 'fill',
      ...cloudinaryDelivery,
    }),
  })),
}))

export const initSelection = {}
data
  .filter(section => section.id !== 'estimate')
  .forEach(section => {
    initSelection[section.id] = {
      ...section.cards[0],
      id: section.id,
    }
  })
